export default __webpack_public_path__ + "static/media/375.36a144f4.png";